import React from 'react';
import { withHydrator } from '@thd-olt-component-react/hydrator';
import { withDynamicComponent, withDynamicImport } from '@thd-nucleus/app-render';
import { withLayoutGroup } from '@thd-olt-component-react/layout-manager';
import { dataModel } from './ReviewDataModel';
import { RatingsAndReviewsDefaultProps, StoreRatingsAndReviewsPropTypes } from './RatingsAndReviewsPropTypes';
import { RatingsAndReviewsPlaceholder } from './RatingsAndReviewsPlaceholder';

const placeholder = (
  <RatingsAndReviewsPlaceholder
    color="#E0E0E0"
    showLoadingAnimation
  />
);

const ImportedComponent = withDynamicImport({
  server: () => {
    return __webpack_require__(require.resolveWeak('./StoreRatingsAndReviewsMobile')).StoreRatingsAndReviewsMobile;
  },
  client: () => {
    return import(
      /* webpackPrefetch: true, webpackChunkName: "store-ratings-and-reviews-mobile" */
      './StoreRatingsAndReviewsMobile');
  },
  placeholder,
  name: 'StoreRatingsAndReviewsMobile',
});

const HydratedComponent = withHydrator({
  delay: 2000,
  id: 'store-section-rr',
  placeholder,
  preserveCtxVal: 'clientStore',
  scrollBuffer: 750,
}, ImportedComponent);

const DynamicComponent = withDynamicComponent(HydratedComponent);
export const StoreRatingsAndReviewsMobileImporter = withLayoutGroup({
  name: 'ratings'
}, DynamicComponent);

StoreRatingsAndReviewsMobileImporter.displayName = 'StoreRatingsAndReviewsMobileImporter';
StoreRatingsAndReviewsMobileImporter.propTypes = StoreRatingsAndReviewsPropTypes;

StoreRatingsAndReviewsMobileImporter.defaultProps = RatingsAndReviewsDefaultProps;

StoreRatingsAndReviewsMobileImporter.dataModel = dataModel;
